





import {apiV1AdminLifePath, apiV1AdminLivesPath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostNew from '@/components/admin/PostNew'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    PostForm
  }
})
export default class LifeNew extends PostNew {
  path = 'lives'
  createPath = apiV1AdminLivesPath()

  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminLifePath('new')
    return super.mounted()
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '沖縄生活情報一覧',
        to: '/admin/lives',
        exact: true
      },
      {
        text: '沖縄生活情報新規作成'
      }
    ]
  }
}
